import React, { useState } from 'react'
import Search from '../../search'
import { HeaderSearch } from '../style'

export const SearchIcon = () => {
  const [showSearch, setShowSearch] = useState(false)
  let bodyElement: any

  const handleSearchClick = (e: any) => {
    e.preventDefault()

    if (!showSearch) {
      let searchInput: any = document.querySelector('#gcs__input')

      if (searchInput) {
        searchInput?.focus()
        if (bodyElement) {
          bodyElement.classList.add('overflow-hidden')
        }
      }
    } else {
      if (bodyElement) {
        bodyElement.classList.remove('overflow-hidden')
      }
    }

    setShowSearch(!showSearch)
  }

  return (
    <>
      <HeaderSearch className="headerSearch" data-cy="headerSearch" onClick={handleSearchClick}>
        <a className="MainHeader-gcsSearchButton searchIcon">
          <svg
            xmlns="https://www.w3.org/2000/svg"
            xmlnsXlink="https://www.w3.org/1999/xlink"
            width="15"
            height="16"
            viewBox="0 0 15 16">
            <defs>
              <path
                id="search2-a"
                d="M10.741 10.464l3.803 3.802a.67.67 0 11-.948.948L9.794 11.41A6.03 6.03 0 116.03.67a6.03 6.03 0 014.711 9.794zm-4.711.926a4.69 4.69 0 100-9.38 4.69 4.69 0 000 9.38z"></path>
            </defs>
            <use fillRule="evenodd" xlinkHref="#search2-a"></use>
          </svg>
        </a>
      </HeaderSearch>
      <Search open={showSearch} handleSearchClick={handleSearchClick} />
    </>
  )
}
